import { render, staticRenderFns } from "./CertificationsTable.vue?vue&type=template&id=cc0d83ae&"
import script from "./CertificationsTable.vue?vue&type=script&lang=js&"
export * from "./CertificationsTable.vue?vue&type=script&lang=js&"
import style0 from "./CertificationsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports